/* Order History Data Table */
let priceTemplate = `<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>{{price}}</bdi></span>`;
let tableOptions = {
    "info": false,
    "pageLength": 3,
    "pagingType": "simple_numbers",
    "searching": true,
    "language": {
        "emptyTable": "No record found."
    },
    "fnDrawCallback": function(oSettings) {
        let $tablePageWrapper = $('#'+oSettings.sTableId+'_paginate');
        if($tablePageWrapper.length) {
            let $tablePages = $tablePageWrapper.find('span > a.paginate_button');
            if($tablePages === "undefined" || $tablePages.length <= 1) {
                $tablePageWrapper.hide();
            }
        }

    }
};

if(window.innerWidth <= 767) {
    tableOptions.pageLength = -1;
}

$(function () {
    let $table = $('table[data-role="datatable"]');
    if($table.length) {
        let $tableHead = $table.find('thead > tr > th');
        let $tableEmptyMsg = $table.attr("data-empty-msg");
        let $tablePageSize = parseInt($table.attr("data-page-size"));
        if(!$tablePageSize) {
            $tablePageSize = tableOptions.pageLength;
        }
        if($tableEmptyMsg === "undefined" || !$tableEmptyMsg) {
            $tableEmptyMsg = tableOptions.language.emptyTable;
        }
        let $orderableCols = [];
        $tableHead.each(function (index, element){
            if($(element).attr('data-order')) {
                $orderableCols.push(index);
            }
        });

        let $options = $.extend({}, tableOptions, {
            "pageLength" : $tablePageSize,
            "columnDefs": [
                { "orderable": true, "targets": $orderableCols }
            ],
            "language": {
                "emptyTable": $tableEmptyMsg
            },
        })
        let $dt = $table.DataTable($options);
        // $table
        $('#order_filter_box').on('keyup change', _.debounce(function () {
            $dt.search($(this).val()).draw();
        }, 300))

        $( window ).resize(function() {
            if(window.innerWidth <= 767) {
                $dt.page.len( -1 ).draw();
            } else {
                $dt.page.len( $tablePageSize ).draw();
            }
        });
    }

    /**
     *  Tabs
     */
    let $tab = $('[data-role="tabs"]');
    $tab.each(function (index, ele){
        let $tabContent = $($(ele).attr('data-target'));
        if($tabContent.length) {
            $(ele).find('a').on('click', function (event) {
                event.preventDefault();
                $tabContent.find('> .active').removeClass('active');
                $(ele).find('li.active').removeClass('active');
                let $targetContent = $($(this).attr('href'));
                $targetContent.addClass('active');
                $(this).parent("li").addClass('active');
            });
        }
    });

    // Prepare Invoices form
    let $payBalanceForm = $('#b2b_prepare_invoice_payment');
    if($payBalanceForm.length) {
        $payBalanceForm.on('submit', function (event){
            event.preventDefault();
            let $invoices = $payBalanceForm.find('[name="b2b\\[invoices\\]"]').val();
            if($invoices && $invoices.length) {
                $.ajax({
                    data: $payBalanceForm.serialize(),
                    type: 'post',
                    url:  b2bRequest.ajaxurl,
                    success: function(data) {
                        let result = JSON.parse(data);
                        if(result.success && result.forward) {
                            window.location.href = result.forward;
                        } else {
                            alert(result.msg);
                        }
                    }
                });
            } else {
                alert(`Please select invoices to pay.`);
            }

        })
    }


    $('.pay-balance .invoice_inpt').on("click",function(){
        let invoices = [],
            amount = 0;

        $(".pay-balance input:checkbox[name=invoice]:checked").each(function(){
            invoices.push($(this).val());
            amount += parseFloat($(this).attr('data-amount'));
        });

        // $("#amount_to_pay").text(amount);
        let $priceHtml = priceTemplate.replace('{{price}}', _.round(amount, 2).toFixed(2));
        $('[name="b2b[amount]"]').val(amount);
        $('[name="b2b[invoices]"]').val(_.toString(invoices));
        $('#summary-box .woocommerce-Price-amount').replaceWith($priceHtml);
        if(amount <= 0) {
            $('#b2b_prepare_invoice_payment').hide();
            $('#b2b_prepare_invoice_payment').find('[type="submit"]').attr('disabled','disabled');
        } else {
            $('#b2b_prepare_invoice_payment').show();
            $('#b2b_prepare_invoice_payment').find('[type="submit"]').removeAttr('disabled');
        }

    });

    /* Payment Form Submission */
    $("#processed_invoice_pay").submit(function(event){
        event.preventDefault();
        var selected_method = $('input[name="wc-authnet-payment-token"]:checked').val();

        if( selected_method === 'new' || selected_method === undefined ) {

            let card_no = $("#authnet-card-number").val(),
                cvv     = $("#authnet-card-cvc").val(),
                expiry  = $("#authnet-card-expiry").val();

            /* Card Validations */
            if( card_no === '' ) {
                $("#invoice_pay_mess").text("Please Enter Card Number");
                return false;
            }else{
                $("#invoice_pay_mess").text("");
            }

            if( card_no.length < 16 ) {
                $("#invoice_pay_mess").text("Please Enter Correct Card Details");
                return false;
            }else{
                $("#invoice_pay_mess").text("");
            }

            /* Card Expires */
            if( expiry === '' ) {
                $("#invoice_pay_mess").text("Please Enter Card Expiry Details");
                return false;
            }else{
                $("#invoice_pay_mess").text("");
            }

            /* Card CVV */
            if( cvv === '' ) {
                $("#invoice_pay_mess").text("Please Enter Card CVV.");
                return false;
            }else{
                $("#invoice_pay_mess").text("");
            }

        }
        var form = $(this).serialize();
        var formdata = new FormData();
        formdata.append('action','fws_process_payment');
        formdata.append('security',b2bRequest.security)
        formdata.append('data',form);
        $('[data-role="pay-card-btn"]').attr('disabled', 'disabled');
        $.ajax({
            data: formdata,
            type: 'post',
            contentType: false,
            processData: false,
            url:  b2bRequest.ajaxurl,
            success: function(data) {
                result = JSON.parse(data);
                $('[data-role="pay-card-btn"]').removeAttr('disabled');
                if( result.response === 'success' && result.forward) {
                    window.location.replace(result.forward);
                    // window.location.href = result.forward;
                } else if( result.response === 'error' ) {
                    alert("There some error. Please try again.")
                } else if( result.response === 'No_address' ) {
                    alert("Billing and Shipping address are not available.")
                } else if( result.response === 'error' && result.message !== undefined && result.message.length) {
                    alert(result.message);
                } else {
                    alert(data);
                }
            }
        });
    });
    // Make Payment
    let $payCardButtons = $('[data-role="pay-card-btn"]');
    let $paymentForm = $('#processed_invoice_pay');
    if($payCardButtons.length && $paymentForm.length) {
        $payCardButtons.on('click', function (event){
            event.preventDefault();
            let $cardId = $(this).attr('data-saved-card');
            let $card = $(this).attr('data-card');
            $paymentForm.find('[name="wc-authnet-payment-token"]').val($card);
            $('#'+$cardId).trigger('click');
            $paymentForm.trigger('submit');
        });
    }

    // Editable Invoice Amount
    let $editPaySummaryBox = $('[data-id="pay-invoice-summary"]');
    let $editInputBox = $editPaySummaryBox.find('[name="invoice_amount_edit"]');
    if($editInputBox.length && $paymentForm.length) {
        $editInputBox.on('change keyup', _.debounce(function () {
            let $max = parseFloat($editInputBox.attr('data-max'));
            let $min = parseFloat($editInputBox.attr('data-min'));
            let $value = parseFloat($(this).val());
            let $remainingPrice = 0;
            if($value >= $min && $value <= $max) {
                $paymentForm.find('[name="form_amount_to_pay"]').val($value);
                $remainingPrice = ($max - $value) >= 0 ? ($max - $value) : 0;
            } else {
                $(this).val($max);
                $paymentForm.find('[name="form_amount_to_pay"]').val($max);
            }
            let $remainingPriceHtml = priceTemplate.replace('{{price}}', _.round($remainingPrice, 2).toFixed(2));
            $editPaySummaryBox.find('[data-id="remaining-amount"] > .row-value').html($remainingPriceHtml);
        }, 300));

    }

    // Saved Payment Card/Method and Make Payment
    let $savedToken = $('.payment-method [name="card_token_id"]');
    if($savedToken.length && $payCardButtons.length === 1 && $paymentForm.length) {
        $savedToken.on('click', function(event){
            let $tokenId = $(this).val();
            $payCardButtons.attr('data-saved-card','wc-authnet-payment-token-'+$tokenId);
            $payCardButtons.attr('data-card',$tokenId);
            $paymentForm.find('[name="wc-authnet-payment-token"]').val($tokenId);
        })
    }


    // Add Card Validation
    let cardForm = $('#add_payment_method');
    if(cardForm.length) {
        let cardNumber = cardForm.find('[name="authnet-card-number"]');
        let cardExpiry = cardForm.find('[name="authnet-card-expiry"]');
        let cardCVV = cardForm.find('[name="authnet-card-cvc"]');
        cardForm.find('input[name*="authnet"]').on('change keyup', function (){
            let cardNumberValidation = ccValid.number(cardNumber.val());
            let cardExpiryValidation = ccValid.expirationDate(cardExpiry.val());
            let cardCVVvalidation = ccValid.cvv(cardCVV.val());
            if(cardNumberValidation.isValid && cardExpiryValidation.isValid && cardCVVvalidation.isValid) {
                cardForm.find('[type="submit"]').removeAttr('disabled');
            } else {
                cardForm.find('[type="submit"]').attr('disabled', 'disabled');
            }
        })
        cardForm.on('submit', function (event){
            let cardNumberValidation = ccValid.number(cardNumber.val());
            let cardExpiryValidation = ccValid.expirationDate(cardExpiry.val());
            let cardCVVvalidation = ccValid.cvv(cardCVV.val());
            if(!cardNumberValidation.isValid || !cardExpiryValidation.isValid || !cardCVVvalidation.isValid) {
                event.preventDefault();
                setTimeout(function (){
                    cardForm.unblock();
                    cardForm.find('[type="submit"]').attr('disabled', 'disabled');
                }, 3000);
            }
        });
    }

    // Checkout Form Updates
    const updateCheckoutBlocking = () => {
        let $poVal = $('[name="purchase-order-number"]').val();
        if($poVal && $poVal !== "" && $poVal.length) {
            $('#place_order').removeAttr('disabled');
        } else {
            $('#place_order').attr('disabled', 'disabled');
        }
    }
    let $checkoutForm = $('[name="checkout"]');
    if($checkoutForm.length) {
        let tmpPOfield = $checkoutForm.find('[name="po_number"]');
        let mainPOfield = $checkoutForm.find('[name="purchase-order-number"]');
        tmpPOfield.val(mainPOfield.val()); // Make sure Tmp field is updated with actual value
        tmpPOfield.on('change keyup', _.debounce(function (){
            mainPOfield.val($(this).val());
            $('[name="purchase-order-number"]:text').val($(this).val());
            updateCheckoutBlocking();
        }, 300));

        setTimeout(function (){
            // $checkoutForm.find('.wc_payment_method:not(.payment_method_purchase_order_gateway)').remove();
            updateCheckoutBlocking();
        },2000)
    }
});




